// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bae4e219","455":"a8c8c9d6","977":"3ae6c338"}[chunkId] + ".chunk.js";
};